import { useQuery } from '@tanstack/react-query'
import {
  getLocationFromPostcode,
  getPostcodeFromPartialPostcode,
} from './services'

export const useGetLocationFromPostcode = postcodeInput => {
  const postcode = postcodeInput?.replace(/\s/g, '')

  const postcodeQuery = useQuery(
    ['fullPostcodeFromPartial', postcode],
    () => getPostcodeFromPartialPostcode(postcode),
    {
      enabled: !!postcode && postcode?.length > 2 && postcode?.length < 5,
      retry: 1,
    }
  )

  const searchByPostcode =
    !!postcode && postcode?.length > 4
      ? postcode
      : postcodeQuery
      ? postcodeQuery?.data?.postcode?.replace(/\s/g, '')
      : ''

  const query = useQuery(
    ['locationFromPostcode', postcode],
    () => getLocationFromPostcode(searchByPostcode),
    {
      enabled: postcode?.length > 4 || !!postcodeQuery?.data,
      retry: 1,
    }
  )

  return {
    ...query,
    isLoading:
      (query.isLoading && query.fetchStatus !== 'idle') ||
      (postcodeQuery.isLoading && postcodeQuery.fetchStatus !== 'idle'),
    isLoadingOnly: query.isLoading || postcodeQuery.isLoading,
  }
}
